import React, {ChangeEvent, FocusEvent, useCallback, useEffect, useState} from 'react';

import b_ from 'b_';
import emailValidator from 'email-validator';

import {Textinput} from 'client/common/components/lego';

import {useUserEmail} from 'client/common/hooks/user';
import {useUpdateEmail} from 'client/common/hooks/box';

import I18N from 'assets/i18n/brandlift-project';

import {EmailBlockProps} from './types';

import './publication.css';

const i18n = I18N.common.publication;
const b = b_.with('publication');

export function EmailBlock({slug, isBox, initialEmail, onValidityChange}: EmailBlockProps) {
    const [email, setEmail] = useState<string>();
    const userEmail = useUserEmail();
    const updateBoxEmail = useUpdateEmail(slug);
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        setEmail(initialEmail ?? userEmail);
    }, [initialEmail, userEmail]);

    const handleChangeEmail = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            setIsValid(true);
            onValidityChange(true);
            setEmail(event.target.value);
        },
        [onValidityChange]
    );

    const handleBlurEmail = useCallback(
        async (event: FocusEvent<HTMLInputElement>) => {
            const newEmail = event.target.value;
            const isNewEmailValid = emailValidator.validate(newEmail);

            setIsValid(isNewEmailValid);
            onValidityChange(isNewEmailValid);

            if (isBox && isNewEmailValid) {
                await updateBoxEmail(newEmail);
            }
        },
        [isBox, onValidityChange, updateBoxEmail]
    );

    return (
        <div className={b('email-block')}>
            <span className={b('email-label')}>{i18n.emailForResults}</span>
            {isBox ? (
                <Textinput
                    addonAfter={
                        !isValid && <span className={b('error-label')}>{i18n.enterValidEmail}</span>
                    }
                    className={b('email-input')}
                    onBlur={handleBlurEmail}
                    onChange={handleChangeEmail}
                    placeholder={i18n.placeholder.email}
                    size='m'
                    state={isValid ? undefined : 'error'}
                    value={email}
                    view='dl'
                />
            ) : (
                <span>{email}</span>
            )}
        </div>
    );
}
